<component :is="componentName" v-bind="props"></component>